import { render, staticRenderFns } from "./SpFormProfile.vue?vue&type=template&id=0f46f5de&"
import script from "./SpFormProfile.vue?vue&type=script&lang=js&"
export * from "./SpFormProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports